import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { PayVideoQueryParams } from "./models/PayVideo.query";
import { PayVideoResponseDTO } from "./models/PayVideo.responce.dto";

export abstract class PayVideoApi {
  static payVideo = async (params: PayVideoQueryParams) => {
    const response = GbApiRequestService.post(
      "userRpc",
      new URLSearchParams({
        type: JSON.stringify({
          dataMap: params,
          processorClass: "PayVideo",
        }),
      }),
    );

    return await withSchemaValidation(response, PayVideoResponseDTO);
  };
}
